import React from "react";
import BusLiveMap from "./components/BusLiveMap";
import BusVehicleList from "./components/BusVehicleList";
import DriverControl from "./components/DriverControl";
import { DriverTripProvider } from "./context/DriverTripContext";

export default function BusModule({
  vehicles,
  selectedStakeholder,
  onOpenVehicle,
  onSellTicket,
  onToggleFavorite,
}) {
  // ----------------------------
  // DRIVER VIEW: FULLSCREEN
  // ----------------------------
  if (selectedStakeholder === "Driver") {
    return (
      <div className="w-full h-full bg-black">
        <DriverTripProvider>
          <DriverControl />
        </DriverTripProvider>
      </div>
    );
  }

  // ----------------------------
  // OTHER STAKEHOLDERS: NORMAL LAYOUT
  // ----------------------------
  return (
    <div className="relative w-full h-full flex flex-col lg:flex-row">

      {/* LEFT: MAP */}
      <div className="w-full lg:w-2/3 h-56 lg:h-auto p-2">
        <BusLiveMap
          vehicles={vehicles}
          onSelectVehicle={onOpenVehicle}
        />
      </div>

      {/* RIGHT: ROLE-BASED PANEL */}
      <div className="w-full lg:w-1/3 p-2 border-l border-gray-700 overflow-y-auto">
        <BusVehicleList
          vehicles={vehicles}
          stakeholder={selectedStakeholder}
          onView={onOpenVehicle}
          onSell={onSellTicket}
          onFavorite={onToggleFavorite}
        />
      </div>
    </div>
  );
}
